import React from "react"

import {
	Avatar,
	Badge,
	Paper,
	Stack,
	Typography,
} from "@mui/material"

import Icon from "@mdi/react"

interface SbCardProps extends Readonly<{ children?: React.ReactNode }>
{
	backgroundImage: any

	notifications?: number
	showNotificationsBadge?: boolean
	avatarBackgroundColour: string
	avatarIcon: string

	title: string|null
	subtitle?: string
	mainValue?: string

	height?: string

	onClick?: React.MouseEventHandler
}
export class SbCard extends React.Component<SbCardProps, {}>
{
	static defaultProps = {
		height: "150px",
		showNotificationsBadge: true,
	}

	render()
	{
		const avatarContent = (
			<Avatar sx={{
				backgroundColor: this.props.avatarBackgroundColour,
				width: 64,
				height: 64,
			}}>
				<Icon path={this.props.avatarIcon} size="40px" />
			</Avatar>
		)

		return (
			<Paper
				elevation={0}
				sx={{
					height: this.props.height,
					px: 2,
					py: 2,
					position: "relative",
					backgroundImage: `url(${this.props.backgroundImage})`,
					backgroundSize: "160% 100%",
					backgroundPosition: "0% 50%",
					cursor: "pointer",
				}}
				onClick={this.props.onClick}
			>
				<Stack direction="column" display="flex" justifyContent="space-between" height="100%">
					<Typography sx={{ color: 'white', fontSize: 16 }}>{this.props.title ?? <>&nbsp;</>}</Typography>
					{this.props.mainValue &&
						<Typography sx={{ color: 'white', fontWeight: 'medium', fontSize: 28 }}>
							{this.props.mainValue}
						</Typography>
					}

					{this.props.children}
				</Stack>

				<div style={{
					position: "absolute",
					right: "16px",
					top: "16px",
				}}>
					{
						this.props.showNotificationsBadge
							? (
								<Badge color="error" overlap="circular" badgeContent={this.props.notifications ?? 0} max={999}>
									{avatarContent}
								</Badge>
							)
							: avatarContent
					}
				</div>
			</Paper>
		)
	}
}
